export const imageUrlsChiTietCuaHang = {
    favicon: "img/wedding/1.png",
    anhPhongNen : "img/wedding/anhBG.png",
    duongKe: "img/vpos/imgChiTietCuaHang/duongke.png",
    
  };
  